module.exports = __webpack_public_path__ + "static/WhatBgDesktop3-4952eb7b2083a2668b8fab625e1f3824.png";